import { Component } from "@angular/core";
import {
  AbstractControl,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { Router, ActivatedRoute } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { FactServiceService } from "./fact-service.service";
import Swal from "sweetalert2";
import { datosFacturacion } from "../../entities/datosFacturacion";
import { DatosFacturacionService } from "src/app/shared/datos-facturacion.service";

@Component({
  selector: "app-facturacion",
  templateUrl: "./facturacion.component.html",
  styleUrls: ["./facturacion.component.scss"],
})
export class FacturacionComponent {
  public idOrder: number;
  public facturacionForm: FormGroup;
  public listaDatosFacturacion: datosFacturacion[] = [];
  public modalSwitch: boolean = false;
  public datosFactura: datosFacturacion;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private factService: DatosFacturacionService,
    private toastr: ToastrService,
  ) {}

  ngOnInit() {
    this.initForm();
    this.route.params.subscribe((param) => {
      this.idOrder = param["id"];
    });
    this.obtenerListaDatos();

    
    this.factService.$modal.subscribe((value) => {
      this.modalSwitch = value.statusModal;
      if (value.reloadPage) {
        window.location.reload();
      };
    });
  }

  obtenerListaDatos() {
    this.factService.obtenerListaDatos().subscribe(
      (response) => {
        this.listaDatosFacturacion = response;        
    });
  }

  initForm() {
    this.facturacionForm = this.fb.group({
      datos: new FormControl("", [Validators.required]),
    });
  }

  soloNumerosDomFisc(event: any): void {
    const input = event.target as HTMLInputElement;
    const soloNumeros = input.value.replace(/[^0-9]/g, "");
    this.facturacionForm.patchValue({ domicilioFiscal: soloNumeros });
  }

  soloNumerosRegimenFiscal(event: any): void {
    const input = event.target as HTMLInputElement;
    const soloNumeros = input.value.replace(/[^0-9]/g, "");
    this.facturacionForm.patchValue({ regimenFiscal: soloNumeros });
  }

  soloLetrasNumerosExt(event: any): void {
    const input = event.target as HTMLInputElement;
    const soloLetrasNumeros = input.value.replace(/[^a-zA-Z0-9]/g, "");
    this.facturacionForm.patchValue({ rfc: soloLetrasNumeros });
  }

  changeCdfi() {
    const control =  this.facturacionForm.get('datos').value;
    // console.log(control);
    
    this.datosFactura = {
      idOrden: this.idOrder,
      rfc: control.rfc,
      nombre: control.nombre,
      cp: control.cp,
      regimenFiscal: control.regimenFiscal,
      usoCfdi: control.usoCfdi
    }
  }

  facturar() {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // Para un desplazamiento suave
    });
    
    // Swal.fire({
    //   title: "¡Factura Generada!",
    //   text: "La factura se ha generado con éxito. Haz clic en el botón de abajo para descargar tus archivos.",
    //   icon: "success", // Puedes cambiar 'success' por 'error', 'warning', 'info', etc.
    //   confirmButtonText: '<i class="fa fa-arrow-circle-down" aria-hidden="true"></i> &nbsp; Descargar',
    //   onClose: () => {
    //     // console.log(result);
    //   },
    // });
    if (this.facturacionForm.invalid) {
      this.facturacionForm.markAllAsTouched();
      this.toastr.error("Debes completar todos los campos");
    } else {
      
      this.factService.facturar(this.datosFactura).subscribe(
        (result: any) => {
          if (result !== 'Tu periodo para facturar se ha expirado.') {
            Swal.fire({
              title: "¡Factura Generada!",
              text: "La factura se ha generado con éxito. Haz clic en el botón de abajo para descargar tus archivos.",
              icon: "success",
              confirmButtonText: '<i class="fa fa-arrow-circle-down" aria-hidden="true"></i> &nbsp; Descargar',
              onClose: () => {
                window.location.href = result.urlFactura;
                // window.location.href = "https://download.winzip.com/gl/nkln/winzip28-downwz.exe";
              }
            });
          } else {
            Swal.fire({
              title: "¡Ops!",
              text: result,
              icon: "error",
              confirmButtonText: "Cerrar"
            });
          }
        },
        (err) => {
          Swal.fire({
            title: "¡Ops!",
            text: err.error,
            icon: "error",
            confirmButtonText: "Cerrar"
          });
        }
      );
      // console.log(data);
    }
  }

  volver() {
    this.router.navigate(["/pages/estatus-orden", this.idOrder]);
  }

  modalDatosFacturacion() {
    this.modalSwitch = true;
    // console.log(this.modalSwitch);
  }
}
